import { Badge } from "@/components/ui/badge";
import {
  Select,
  SelectContentDialog,
  SelectItem,
  SelectTriggerIcon,
  SelectValue,
} from "@/components/ui/select";
import { statusColumns } from "./PursuitKanban";

export default function PursuitStatusSelect(props) {
  return (
    <Select {...props}>
      <SelectTriggerIcon className="border-none bg-transparent hover:bg-accent hover:text-accent-foreground">
        <SelectValue placeholder="Select status" />
      </SelectTriggerIcon>
      <SelectContentDialog className="[&_*[role=option]>span>svg]:shrink-0 [&_*[role=option]>span>svg]:text-muted-foreground/80 [&_*[role=option]>span]:end-2 [&_*[role=option]>span]:start-auto [&_*[role=option]>span]:flex [&_*[role=option]>span]:items-center [&_*[role=option]>span]:gap-2 [&_*[role=option]]:pe-8 [&_*[role=option]]:ps-2">
        {statusColumns.map((status) => (
          <SelectItem value={status.id} key={status.id}>
            <Badge
              variant="gray"
              className="flex items-center gap-2 rounded-md"
            >
              <span className="truncate">{status.title}</span>
            </Badge>
          </SelectItem>
        ))}
      </SelectContentDialog>
    </Select>
  );
}
